import React from "react";
import { Row, Col } from "react-bootstrap";
import { AnalystCard } from "./AnalystCard";

export const AnalystGroup = ({ group, speciality, analysts = [] }) => {
  return (
    <section id={speciality}>
      <h3 className="h2 font-weight-lighter text-dark mb-2">{group}</h3>
      <h4 className="h3 font-weight-lighter text-primary mb-3">{speciality}</h4>

      <Row className="mx-n2 mb-5">
        {analysts.map((analyst, key) => (
          <Col key={key} md={6} className="px-2 d-flex">
            <AnalystCard {...analyst} />
          </Col>
        ))}
      </Row>
    </section>
  );
};
